import { BrowserRouter, NavLink, Route, Routes } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import PasswordReset from "./PasswordReset";
import SetNewPassword from "./SetNewPassword";

import DailyContent from "./DailyContent";
import WellnessGym from "./WellnessGym"
import Onboarding from "./Onboarding";
import OnboardingDemo from "./OnboardingDemo";
import LandingForm from "./LandingForm";
import LandingFormBeta from "./LandingFormBeta"
import ImportResources from "./ImportResources";
import Home from "./Home";
// import Welcome from "./Welcome"
import Profile from "./Profile"
import Progress from "./Progress"
import ProblematicLog from "./ProblematicLog"
import Support from "./Support";
import Settings from "./Settings";
import About from "./About";
import PreLoad from "./PreLoad";
import InDevelopment from "./InDevelopment";
import Notifications from "./Notifications";
import Chat from "./ChatDemo2";
// import ChatDemo from "./ChatDemo";
import HomeDemo from "./HomeDemo";
import Sandbox from "./Sandbox";
import { ChromeConnect, ConnectSuccess } from "./ChromeConnect";



import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";
import { useEffect, useState } from "react";
import axios from 'axios';
import { resetUserSession, setUserSession, getToken, getUser } from "./service/AuthService";

import progressBttn from './assets/cupProgress.svg';
import homeBttn from './assets/homeBttn.svg';
import supportBttn from './assets/supportBttn.svg';
import chatBttn from './assets/chatBttn.svg';
import dumbellLarge from './assets/dumbbell-large-svgrepo-com.svg';
import dumbell from './assets/dumbbell-svgrepo-com.svg';

import './css/Main.css';

const verifyUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/verify';

function App() {

  const [isAuthenticating, setAuthenticating] = useState(true);

  useEffect(() => {
    let mounted = true;
    const token = getToken();
    if (token === 'undefined' || token === undefined || token === null || !token) {
      setAuthenticating(false);
      return () => {
        mounted = false;
      };
    }

    const requestConfig = {
      headers: {
        'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
      },
      timeout: 10000,
    };

    const requestBody = {
      user: getUser(),
      token: token
    };

    axios
      .post(verifyUrl, requestBody, requestConfig)
      .then((response) => {
        if (!mounted) return;
        setUserSession(response.data.user, response.data.token);
      })
      .catch(() => {
        if (!mounted) return;
        resetUserSession();
      })
      .finally(() => {
        if (!mounted) return;
        setAuthenticating(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const token = getToken();
  if (isAuthenticating && token) {
    return <div className="content">Authenticating...</div>
  }

  const handleHeaderClick = (event) => {
    // console.log('here yo:', event.target.classList)
    if (event.target.classList.contains('header-active')) {
      return;
    }

    // Remove the "active" class from all elements with that class
    const activeElements = document.querySelectorAll('.header-active');
    activeElements.forEach(element => {
        element.classList.remove('header-active');
    });

    // Add the "active" class to the clicked element
    event.target.classList.add('header-active');
  }

  return (
    <div className="App" style={{  display: 'flex', flexFlow: 'column', maxWidth: '500px', margin:'0 auto'}}>
      <div className="donut-parent" >
        <div 
          className="donut" 
          style={{
          // position: 'absolute',
          // top: '50%',
          // left: '45%',
          // transform: 'translate(-0%, -50%)'  
        }}
      ></div>
      </div>
      <BrowserRouter>
        <div className = "header sticky">
          <div className="button-container">
            {/* <NavLink to={"/"}> Home </NavLink> */}
            {/* <NavLink to={"/register"}> Register </NavLink> */}
            {/* <NavLink to={"/login"}> Login </NavLink> */}
            {/* <button> Logout </button> */}
            {/* <NavLink to={"/import-resources"}> Import Resources </NavLink> */}
            {/* <NavLink className="button" to={"/chat-demo"}> Chat Demo </NavLink> */}
            {/* <NavLink to={"/onboarding"} className="button" onClick={handleHeaderClick}> Onboarding <i className="fa fa-comments fa-1x like" aria-hidden="true"></i></NavLink> */}
            {/* <NavLink to={"/onboarding-demo"} className="button" onClick={handleHeaderClick}> Onboarding Demo <i className="fa fa-comments fa-1x like" aria-hidden="true"></i></NavLink> */}
            {/* <NavLink to={"/daily-content"} className="button nav-button" onClick={handleHeaderClick} style={{fontSize: '1.1em', padding:'1em' }}> Home  </NavLink>
            <NavLink to={"/chat"} className="button nav-button" onClick={handleHeaderClick} style={{fontSize: '1.1em', padding:'1em' }}> Chat</NavLink>
            <NavLink to={"/support"} className="button nav-button" onClick={handleHeaderClick} style={{fontSize: '1.1em', padding:'1em' }}> Support  </NavLink> */}
            <NavLink to={"/wellness-gym"} className="button" onClick={handleHeaderClick} style={{fontSize: '1.1em', margin:'0.3em', padding:'1em' }}> 
              {/* Chat <i className="fa fa-comments fa-1x" aria-hidden="true"></i> */}
              <img className="chatBttn" src={dumbellLarge} alt="previousBttn" />
            </NavLink>
            {/* <NavLink to={"/chat"} className="button" onClick={handleHeaderClick} style={{fontSize: '1.1em', margin:'0.3em', padding:'1em' }}> 
              <img className="chatBttn" src={chatBttn} alt="previousBttn" />
            </NavLink> */}
            <NavLink to={"/daily-content"} className="button" onClick={handleHeaderClick} style={{fontSize: '1.1em', margin:'0.3em', padding:'1em' }}> 
              {/* Home <i className="fa fa-home fa-1x" aria-hidden="true"></i>  */}
              <img className="chatBttn" src={homeBttn} alt="previousBttn" />
            </NavLink>
            <NavLink to={"/progress"} className="button" onClick={handleHeaderClick} style={{fontSize: '1.1em', margin:'0.3em', padding:'1em' }}> 
              {/* Home <i className="fa fa-home fa-1x" aria-hidden="true"></i>  */}
              <img className="chatBttn" src={progressBttn} alt="progressBttn" />
            </NavLink>
            {/* <NavLink to={"/progress"}> Progress </NavLink> */}
            <NavLink to={"/support"} className="button" onClick={handleHeaderClick} style={{fontSize: '1.1em', margin:'0.3em', padding:'1em' }}> 
              {/* Support <i style={{fontSize: '14px', paddingLeft: '0.1rem' }} className="fa fa-users fa-1x" aria-hidden="true"></i>  */}
              <img className="chatBttn" src={supportBttn} alt="previousBttn" />
            </NavLink>
            {/* <NavLink to={"/home-demo"}> Home Demo </NavLink> */}
            {/* <NavLink to={"/home-demo"} className="button" onClick={handleHeaderClick}> Home <i className="fa fa-life-ring fa-1x like" aria-hidden="true"></i> </NavLink> */}

            {/* <NavLink to={"/sand-box"}> SandBox </NavLink> */}
            {/* <NavLink to={"/dashboard"}> Dashboard </NavLink> */}
          </div>
        </div>
        {/* <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1.5rem'}}>
          <img style={{ width: '95%', maxWidth: '335px', maxHeight: '75px' }} src={logoBold} alt="Example" />
        </div> */}
        <div className="content">
          <Routes>
            <Route path="*" element={<Login />} /> 
            <Route exact path="/" element={<PreLoad />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="/password-reset" element={<PasswordReset />}/>
            <Route path="/set-new-password" element={<SetNewPassword />}/>
            <Route path="/landing-form" element={<LandingForm />}/>
            <Route path="/landing-form-beta" element={<LandingFormBeta />}/>
            <Route path="/connect" element={<ChromeConnect />}/>
            <Route path="/profile" element={<Profile />}/>

            <Route element={<PublicRoutes/>}>
              <Route path="/register" element={<Register />}/>
            </Route>
            <Route element={<PrivateRoutes/>}>
              <Route path="/connect-success" element={<ConnectSuccess />}/>
              <Route path="/home" element={<Home />}/>
              <Route path="/import-resources" element={<ImportResources />}/>
              <Route path="/daily-content" element={<DailyContent />}/>
              <Route path="/onboarding" element={<Onboarding />}/>
              <Route path="/onboarding-demo" element={<OnboardingDemo />}/>
              <Route path="/progress" element={<Progress />}/>
              <Route path="/relapse" element={<ProblematicLog />}/>
              <Route path="/support" element={<Support />}/>
              <Route path="/settings" element={<Settings />}/>
              <Route path="/about" element={<About />}/>
              <Route path="/in-development" element={<InDevelopment />}/>
              <Route path="/notifications" element={<Notifications />}/>
              {/* <Route path="/pre-load" element={<PreLoad />}/> */}
              <Route path="/chat" element={<Chat />}/>
              <Route path="/wellness-gym" element={<WellnessGym />}/>
              {/* <Route path="/chat-demo" element={<ChatDemo />}/> */}
              <Route path="/home-demo" element={<HomeDemo />}/>
              <Route path="/sand-box" element={<Sandbox />}/>
            </Route>
          </Routes>
        </div>
      </BrowserRouter>    
    </div>
  );
}

export default App;
